<script setup>
import {ref, computed, onMounted} from "vue";
import { useI18n } from "vue-i18n";
import { handleError } from '@/utils/errors';
import DialogConfirmDelet from "@/components/common/DialogConfirmDelet.vue";
import ButtonNew from "@/components/common/button/ButtonNew.vue";
import { useRouter } from "vue-router";
import BaseTable from "@/components/tables/BaseTable.vue";
import BaseQuickSearch from "@/components/common/Filters/BaseQuickSearch.vue";
import BasePage from "@/components/Layouts/BasePage.vue";
import {getAvailableActionsForRoute} from "@/services/api/permissionManagement.js";
import { QrcodeCategoryEntity } from "@/entities/QrcodeCategoryEntity.js";
import { listCategories, deleteCategory } from "@/services/api/qrcode.js";

const { t } = useI18n();
const router = useRouter();
const entity = ref(new QrcodeCategoryEntity());
const items = ref([]);
const totalItems = ref(0);
const loading = ref(false);
const currentPage = ref(1);
const itemsPerPage = ref(10);
const searchText = ref("");
const quickSearchConfig = computed(() => entity.value.pages.list.filters.quickSearch);
const actions = ref([]);
const havePermission = ref(false);
const showDialogConfirmDelet = ref(false);
const itemToDelete = ref(null)
const orderBy = ref(null);

async function fetchData(params = {}) {
  try {
    loading.value = true;
    currentPage.value = params.page ?? currentPage.value;
    if (orderBy.value) params['orderBy'] = orderBy.value.key;

    if (searchText.value) {
      const field = quickSearchConfig.value.searchBy[0];
      params[field] = "%" + searchText.value + "%";
    }

    const response = await listCategories({ limit: itemsPerPage.value, page: currentPage.value, ...params });
    items.value = response.data.items ?? response.data;
    totalItems.value = response.page;
  } catch (error) {
    console.error(error);
    message.error(await handleError(error, t));
  } finally {
    loading.value = false;
  }
}

function onEdit(item) {
  router.push(entity.value.pages.edit.route?.at(-1).replace(':id', item.id));
}
function onDelete(item) { itemToDelete.value = item; showDialogConfirmDelet.value = true; }
async function confirmDelete() { try { await deleteCategory(itemToDelete.value.id); await fetchData(); message.success(t('common.messages.success.itemDeletedSuccessfully')); showDialogConfirmDelet.value=false; } catch(e){ message.error(await handleError(e,t)); } }
async function onPageChange(page){ await fetchData({page}); }
async function onOrderBy(o){ orderBy.value=o; }

onMounted(async () => {
  actions.value = await getAvailableActionsForRoute(entity.value.APIRoute);
  if (!actions.value?.list?.length) { message.error(t("common.messages.errors.403")); } else { havePermission.value = true; await fetchData(); }
});
</script>

<template>
  <BasePage :entity="entity">
    <template #default>
      <v-row class="mb-4">
        <v-col>
          <ButtonNew :route="entity.pages.create.route?.at(-1)" />
        </v-col>
        <v-col class="base-quick-search">
          <BaseQuickSearch style="width:100%" :entity="entity" v-if="quickSearchConfig" :config="quickSearchConfig" v-model="searchText" :fetchData="fetchData" />
        </v-col>
      </v-row>

      <BaseTable :fetchData="fetchData" :entity="entity" :items="items" :loading="loading" :totalItems="totalItems" :currentPage="currentPage" :itemsPerPage="itemsPerPage" :actions="actions" @edit="onEdit" @delete="onDelete" @page-change="onPageChange" @onOrderBy="onOrderBy">
      </BaseTable>

      <DialogConfirmDelet v-model="showDialogConfirmDelet" :item="itemToDelete?.name" @confirm="confirmDelete" />
    </template>
  </BasePage>
  
</template>

